import {combineReducers} from 'redux';
import combinations from './combinations';

const reducers = {
    combinations,
};

export default combineReducers(reducers);
